import Main from './views/Main.vue';
import Page from './views/Page.vue';
import Auth from './views/Auth.vue';
import Notfound from './views/Notfound.vue';

import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import store from './store'

// Охранник для неавторизованных пользователей
// Разрешает доступ только если пользователь не авторизован
const ifNotAuthenticated = (to, from, next) => {
    if (typeof store == 'undefined' || store.getters.isAuth !== true) {
        next()
        return
    }
    // Если пользователь авторизован, перенаправляем на главную
    next('/')
}

// Охранник для авторизованных пользователей
// Разрешает доступ только если пользователь авторизован
const ifAuthenticated = (to, from, next) => {
    if (typeof store == 'undefined' || store.getters.isAuth !== false) {
        next()
        return
    }
    // Если пользователь не авторизован, перенаправляем на страницу авторизации
    next('/auth/')
}

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior(to, from, savedPosition) {
        if (to.path === from.path) {
            return false // отключаем скролл
        }
        if (savedPosition) {
            return savedPosition
        } else {
            return { top: 0 }
        }
    },
    routes: [
        {
            path: '/auth/',
            component: Auth,
            name: 'auth',
            meta: {
                layout: 'main',
                name: 'Авторизация',
                requiresAuth: false // Требуется НЕ быть авторизованным
            },
            beforeEnter: ifNotAuthenticated
        },
        {
            path: '/page/:id/',
            component: Page,
            name:'page',
            meta: {layout: 'main', name: '', show_prev: true},
        },
        {
            path: '/',
            component: Main,
            name: 'main',
            meta: {layout: 'main', name: '', main_page: true}
        },
        {
            path: '/:pathMatch(.*)*',
            component: Notfound,
            name: 'notfound',
            meta: {layout: 'main', name: 'Страница 404', show_prev: true}
        },
    ]
})

export default router
